import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getOneScheduledGame } from '../../services/game.services.js';
// import ErrorOverlay from '../../../components/overlays/ErrorOverlay';
import { useHistory } from 'react-router-dom'; 
import './scheduledGameDetails.css'

const ScheduledGameDetails = (props) => {
  const gameId = props.match.params.gameId;
  const user = useSelector((state) => state.auth.user);
  const operatorTeam = useSelector((state) => state.team.selectedTeam);
  const history = useHistory();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handlegetOneSchedule = async () => {
    try {
      setLoading(true);
      const response = await getOneScheduledGame(gameId, user?.token);
      setData(response.data);
    } catch (err) {
      console.error('Error in team details', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handlegetOneSchedule();
  }, [gameId]);

  const goBackHandler = () => {
    history.goBack();
  };

  return (
    <div className="scheduled-game-details">
      {/* {error && <ErrorOverlay onClose={() => setError(null)} error={error} />} */}
      <div className="header">
       
        <h1>Schedule Details</h1>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="details-content">
          <h2>
            {data?.teamA.teamName} 
            <span className="vs-text">
              {data?.teamB.teamName === data?.awayTeam ? 'VS' : 'AT'} 
            </span>
            {data?.teamB.teamName}
          </h2>
          <p>({data?.conference ? 'Conference' : 'Non Conference'})</p>

          <div className="row">
            <span>Home Team: {data?.homeTeam}</span>
            <span>Away Team: {data?.awayTeam}</span>
          </div>
          <div className="row">
            <span>Date: {data?.date}</span>
            <span>Time: {data?.time}</span>
          </div>

          <button
            className="start-btn"
            onClick={() =>
              history.push('/create-stats-only', {
                subscriptionId: operatorTeam?._id,
                scheduledGameData: data,
              })
            }
          >
            Start Now!
          </button>

          <button className="go-back-btn" onClick={goBackHandler}>
            Go Back
          </button>
        </div>
      )}
    </div>
  );
};


export default ScheduledGameDetails;
